import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './Pages/Home';
import Tablature from './Pages/Tablature';
import CommunityComments from './Pages/CommunityComments';
import AddTabs from './components/AddTabs';
import Login from './Pages/Login';
import SignUp from './Pages/SignUp';
import Contact from './Pages/Contact';
import UserProfile from './Pages/UserProfile';
import CommentsManagement from './components/CommentsManagement';
import UsersManagement from './components/UsersManagement';
import PlaylistDetails from "./Pages/PlaylistDetails"
import NotFoundPage from './Pages/NotFound';




const App = () => {
  // useLocation fait re-rendre App à chaque navigation :
  // le rôle est donc relu juste après une connexion ou une déconnexion
  useLocation()

  const user = JSON.parse(localStorage.getItem("user")) || {}
  const isLogged = Boolean(user.token)
  const isAdmin = isLogged && user.role === "Admin"

  return (

    <Routes>
      <Route path='/' element={<Home />} />
      <Route path="/tablature" element={<Tablature />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/inscription" element={<SignUp />} />
      <Route path='/contact' element={<Contact />} />
      <Route path="/playlist/:tabId"  element={<PlaylistDetails />} />
      <Route path='*' element={<NotFoundPage />} />


      {isLogged && (
        <>
      <Route path="/communaute" element={<CommunityComments />} />
      <Route path='/profile' element={<UserProfile />}/>

      </> 
      )}

{isAdmin && (
  <>
      <Route path="/ajout-tablature" element={<AddTabs />} />
      <Route path="/gestion-des-commentaires" element={<CommentsManagement />}/>
      <Route path="/gestion-des-utilisateurs" element={<UsersManagement />}/>
      </>
      )}
    </Routes>


  );
};

export default App;